
import { makeStyles } from '@material-ui/core/styles';
export const useStyles = makeStyles((theme) => ({
    root: {
        overflow: "visible",
        backgroundColor: theme.palette.common.white,
        boxShadow: theme.shadows[1],
        borderRadius: theme.shape.borderRadius,
        position: "relative",
        padding: 0,
        textTransform: "uppercase",
        height: 32,
        width: "calc(100% + 16px)",
        margin: "24px -8px",
        [theme.breakpoints.down("xs")]: {
            height: 28
        },
        " & .MuiGrid-item":{
            " & .Mui-disabled":{
                backgroundColor:'#e1e2e3',
                color:'#fff'
            }
        }
    },
    tab: {
        overflow: "visible",
        width: "100%",
        padding: 8,
        color: '#bd0912',
        opacity: 0.8,
        fontWeight: '500',
        textTransform: "uppercase",

        fontSize: 12,
        [theme.breakpoints.down("xs")]: {
            fontSize: 10
        }
    },
    indicator: {
        height: 32,
        position: "absolute",
        top: 0,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        boxShadow: [
            `0px 16px 26px -10px ${theme.palette.primary.main}a5`,
            theme.shadows[5]
        ],
        borderRadius: theme.shape.borderRadius,
        opacity: 1,
        color: theme.palette.primary.main,
        backgroundColor: '#bd0912',
        fontSize: 12,
        transform: "scale(0.9)",
        transition: theme.transitions.create("all", {
            easing: "cubic-bezier(0.29, 1.42, 0.79, 1)"
        }),
        [theme.breakpoints.down("xs")]: {
            fontSize: 10
        },
        "& span": { color: theme.palette.primary.contrastText }
    }
}));